var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1143.8 3214.6c12.457 11.09 21.996 19.906 25.094 43.414h1262.3c3.0977-23.508 12.637-32.328 25.094-43.414 20.336-18.145 45.715-40.754 45.715-118.59 0-88.992-86.258-134.68-149.22-168.01-17.746-9.3945-37.945-20.16-51.445-29.988h-1002.7c-13.535 9.8281-33.695 20.594-51.445 29.988-62.961 33.336-149.22 79.02-149.22 168.01 0 77.832 25.379 100.44 45.758 118.59z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2499.4 3294h-1398.8c-23.582 22.895-38.594 54.613-38.594 90 0 69.48 56.52 126 126 126h1224c69.48 0 126-56.52 126-126 0-35.387-15.012-67.105-38.594-90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1314 2790h972v72h-972z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1565.1 1242c-8.8906 96.047-87.695 107.68-89.102 108h649.3c-8.207-1.1523-81.973-14.363-90.469-108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2035 1206c10.223-119.12 113.44-346.61 136.44-396h-742.9c23.004 49.391 126.21 276.84 136.44 396z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2195.5 1494c11.41-15.086 18.504-33.66 18.504-54s-7.0195-38.914-18.289-54h-791.24c-11.449 15.086-18.469 33.66-18.469 54s7.0938 38.914 18.504 54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1849 54h-97.922l-30.023 90h157.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1657.4 594h285.2l-27.758-83.16 119.16 39.746v-309.17l-119.16 39.746 33.73-101.16h-297.14l33.73 101.16-119.16-39.746v309.17l119.16-39.746z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1890 671.51v-41.508h-180v41.508l-273.24 102.49h726.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2034 2160c0-38.914-0.17969-75.492-0.35938-109.98-1.3672-275.07-2.0508-415.44 97.957-520.02h-663.2c99.973 104.62 99.324 244.95 97.957 520.02-0.17969 34.488-0.35938 71.066-0.35938 109.98 0 365.9-208.19 565.09-240.73 594h949.43c-32.582-28.836-240.7-227.3-240.7-594z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingIcon);
export default __webpack_public_path__ + "static/media/kingIcon.0f67bcf462deaea2500f4e1931c48e5a.svg";
export { ForwardRef as ReactComponent };